import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";

import { RootState } from "../../../app/store";
import { CaseAudit } from "../../../api/audits";

import { fetchCaseAudits, upsertCaseAudits } from "./thunks";

export interface CaseAuditsState {
  caseId?: string;
  status: "idle" | "loading" | "succeeded" | "failed";
  audits: EntityState<CaseAudit, string>;
}

const caseAuditsAdapter = createEntityAdapter<CaseAudit, string>({
  selectId: (audit) => audit.audit_id,
});

const initialState: CaseAuditsState = {
  caseId: undefined,
  status: "idle",
  audits: caseAuditsAdapter.getInitialState(),
};

const caseAuditsSlice = createSlice({
  name: "caseAudits",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCaseAudits.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCaseAudits.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.caseId = action.meta.arg;
        caseAuditsAdapter.setAll(state.audits, action.payload.audits ?? []);
      })
      .addCase(fetchCaseAudits.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(upsertCaseAudits.fulfilled, (state, action) => {
        caseAuditsAdapter.upsertMany(state.audits, action.meta.arg.data);
      });
  },
});

export const caseAuditsReducer = caseAuditsSlice.reducer;

export const selectCaseAuditsStatus = (state: RootState) =>
  state.caseAudits.status;

export const {
  selectAll: selectAllCaseAudits,
} = caseAuditsAdapter.getSelectors(
  (state: RootState) => state.caseAudits.audits,
);